/**
 * Сомовые — 16 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const СОМОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'catfish',
        семейство: 'сомовые',
        latin: 'Silurus glanis',
        повадка: 'засадный',
        minKg: 1,
        maxKg: 90,
        typicalKg: 8,
        typicalLengthM: 1.2,
        depthM: 6,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 8, опт: 22, макс: 30 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'лягушка', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'ракушка', вес: 0.4 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'channel_catfish',
        семейство: 'сомовые',
        latin: 'Ictalurus punctatus',
        повадка: 'донный_хищник',
        minKg: 0.3,
        maxKg: 12,
        typicalKg: 1.5,
        typicalLengthM: 0.5,
        depthM: 5,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 10, опт: 26, макс: 32 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'бровка', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'мясо', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'кукуруза', вес: 0.2 },
        ],
    },
    {
        id: 'amur_catfish',
        семейство: 'сомовые',
        latin: 'Pseudobagrus fulvidraco',
        повадка: 'мелочь',
        minKg: 0.05,
        maxKg: 0.6,
        typicalKg: 0.15,
        typicalLengthM: 0.18,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 8, опт: 24, макс: 32 },
        течение: 'слабое',
        держится: ['ил', 'коряги', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'мотыль', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
        ],
    },
    {
        id: 'clarias',
        семейство: 'сомовые',
        latin: 'Clarias gariepinus',
        повадка: 'засадный',
        minKg: 0.5,
        maxKg: 30,
        typicalKg: 3,
        typicalLengthM: 0.7,
        depthM: 2,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 15, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['ил', 'трава', 'коряги'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 11, по: 2 },
        чем: [
            { чем: 'мясо', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'лягушка', вес: 0.4 },
            { чем: 'wobbler', вес: 0.2 },
        ],
    },
    // ── Балканы, Дунай и Междуречье ──
    {
        id: 'greek_catfish',
        семейство: 'сомовые',
        latin: 'Silurus aristotelis',
        повадка: 'донный_хищник',
        minKg: 1,
        maxKg: 25,
        typicalKg: 4,
        typicalLengthM: 0.9,
        depthM: 5,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 10, опт: 23, макс: 30 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'лягушка', вес: 0.4 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'mesopotamian_catfish',
        семейство: 'сомовые',
        latin: 'Silurus triostegus',
        повадка: 'донный_хищник',
        minKg: 1.5,
        maxKg: 30,
        typicalKg: 5,
        typicalLengthM: 1,
        depthM: 5,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 12, опт: 26, макс: 33 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'лягушка', вес: 0.2 },
        ],
    },
    // ── Восточная Европа, Кавказ, Средняя Азия и Сибирь ──
    {
        id: 'brown_bullhead',
        семейство: 'сомовые',
        latin: 'Ameiurus nebulosus',
        повадка: 'мелочь',
        minKg: 0.05,
        maxKg: 0.5,
        typicalKg: 0.15,
        typicalLengthM: 0.22,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 6, опт: 24, макс: 32 },
        течение: 'стоячая',
        держится: ['ил', 'трава', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
        ],
    },
    // ── Восточная Азия ──
    {
        id: 'amur_wels',
        семейство: 'сомовые',
        latin: 'Silurus asotus',
        повадка: 'донный_хищник',
        minKg: 0.3,
        maxKg: 5,
        typicalKg: 1,
        typicalLengthM: 0.5,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'ночная',
        вода: { мин: 8, опт: 24, макс: 31 },
        течение: 'слабое',
        держится: ['коряги', 'ил', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'лягушка', вес: 0.4 },
            { чем: 'spinner', вес: 0.2 },
        ],
    },
    {
        id: 'biwa_catfish',
        семейство: 'сомовые',
        latin: 'Silurus biwaensis',
        повадка: 'засадный',
        minKg: 1,
        maxKg: 12,
        typicalKg: 4,
        typicalLengthM: 0.8,
        depthM: 4,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 8, опт: 22, макс: 29 },
        течение: 'стоячая',
        держится: ['камни', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    // ── Северная Америка ──
    {
        id: 'blue_catfish',
        семейство: 'сомовые',
        latin: 'Ictalurus furcatus',
        повадка: 'донный_хищник',
        minKg: 1,
        maxKg: 35,
        typicalKg: 5,
        typicalLengthM: 0.9,
        depthM: 6,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'круглосуточная',
        вода: { мин: 5, опт: 24, макс: 32 },
        течение: 'сильное',
        держится: ['яма', 'бровка', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'резка', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'spoon', вес: 0.2 },
        ],
    },
    {
        id: 'flathead_catfish',
        семейство: 'сомовые',
        latin: 'Pylodictis olivaris',
        повадка: 'засадный',
        minKg: 1,
        maxKg: 25,
        typicalKg: 5,
        typicalLengthM: 0.85,
        depthM: 5,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 10, опт: 26, макс: 33 },
        течение: 'слабое',
        держится: ['коряги', 'яма', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'лягушка', вес: 0.2 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
    // ── Тропики и Южное полушарие ──
    {
        id: 'goonch',
        семейство: 'сомовые',
        latin: 'Bagarius yarrelli',
        повадка: 'донный_хищник',
        minKg: 2,
        maxKg: 35,
        typicalKg: 8,
        typicalLengthM: 1.2,
        depthM: 5,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 14, опт: 24, макс: 32 },
        течение: 'сильное',
        держится: ['камни', 'яма', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'мясо', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
            { чем: 'spoon', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'wallago',
        семейство: 'сомовые',
        latin: 'Wallago attu',
        повадка: 'засадный',
        minKg: 0.8,
        maxKg: 15,
        typicalKg: 3,
        typicalLengthM: 0.9,
        depthM: 4,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 16, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 6, по: 8 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'лягушка', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'jig', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'mekong_catfish',
        семейство: 'сомовые',
        latin: 'Pangasianodon gigas',
        повадка: 'тропический_гигант',
        minKg: 15,
        maxKg: 120,
        typicalKg: 40,
        typicalLengthM: 1.8,
        depthM: 6,
        depthBandM: 4,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'единичная',
        когда: 'сумеречная',
        вода: { мин: 18, опт: 28, макс: 34 },
        течение: 'слабое',
        держится: ['яма', 'открытая_вода', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'зелень', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'giant_pangasius',
        семейство: 'сомовые',
        latin: 'Pangasius sanitwongsei',
        повадка: 'тропический_гигант',
        minKg: 8,
        maxKg: 90,
        typicalKg: 25,
        typicalLengthM: 1.6,
        depthM: 6,
        depthBandM: 4,
        сложение: 'прогонистое',
        пасть: 'кожистая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 18, опт: 28, макс: 34 },
        течение: 'сильное',
        держится: ['яма', 'открытая_вода', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'redtail_catfish',
        семейство: 'сомовые',
        latin: 'Phractocephalus hemioliopterus',
        повадка: 'тропический_гигант',
        minKg: 4,
        maxKg: 35,
        typicalKg: 12,
        typicalLengthM: 1,
        depthM: 5,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 20, опт: 28, макс: 34 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 11, по: 1 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'мясо', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=siluriforms.js.map